import { useCallback } from 'react';

import { assertNever } from '@/helpers/utils';
import { useFloorplanDesignStore } from '@/modules/floorplanDesign/store/useFloorplanDesignStore';
import { areasToFlatCollection } from '@/modules/floorplanDesign/helpers';

export const useIsLoadTypeBeingUsedCheck = () => {
  const isLoadTypeBeingUsed = useCallback((id: string): boolean => {
    const areas = areasToFlatCollection(useFloorplanDesignStore.getState().design.areas);

    // eslint-disable-next-line array-callback-return
    const isInUse = areas.some((area) => {
      const { areaType } = area;
      switch (areaType) {
        case 'HIGHWAY':
        case 'STATIONARY':
          return false;
        case 'RACKING':
          return area.rackSpec.loadTypes.some((item) => item.loadTypeId === id);
        case 'SINGULAR':
          return area.stationSpec.loadTypeIds.includes(id);
        case 'MANUAL':
          return area.stationSpec.loadTypeIds.includes(id);
        default:
          assertNever(areaType);
      }
    });

    return isInUse;
  }, []);

  return { isLoadTypeBeingUsed };
};
